import { useEffect, useRef } from 'react';

export default function ParallaxOrb() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let mx = window.innerWidth / 2;
    let my = window.innerHeight / 2;
    let ox = 0;
    let oy = 0;
    let tx = 0;
    let ty = 0;
    let raf;

    function onMove(e) {
      mx = e.clientX;
      my = e.clientY;
      tx = (mx - window.innerWidth / 2) * 0.35;
      ty = (my - window.innerHeight / 2) * 0.35;
    }

    function tick() {
      ox += (tx - ox) * 0.04;
      oy += (ty - oy) * 0.04;
      el.style.transform = `translate(-50%, -50%) translate(${ox}px, ${oy}px) scale(${1 + Math.abs(ox + oy) * 0.0004})`;
      raf = requestAnimationFrame(tick);
    }

    window.addEventListener('mousemove', onMove);
    raf = requestAnimationFrame(tick);
    return () => {
      window.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return <div ref={ref} className="orb orb-1" id="orb-1" />;
}
